<!-- TODO: @cristian -->
<div class="container container-es">
  <div class="bg"></div>
  <div class="panel">
    <div>
      <div class="title">
        <h1>
          <em [innerHTML]="'landing.quote.text' | translate"></em>
          <span>{{ 'landing.quote.author' | translate }}</span>
        </h1>
      </div>
      <div class="info">
        <p [innerHTML]="'landing.info1' | translate"></p>
        <p [innerHTML]="'landing.info2' | translate"></p>
        <!-- <p [innerHTML]="'landing.info3' | translate"></p> -->
        <p [innerHTML]="'landing.steps.title' | translate"></p>
      </div>
      <div class="steps-group">
        <div class="step step01">
          <div class="step-number">1</div>
          <div class="step-title">
            <span>{{ 'landing.steps.step1.title' | translate }}</span>
          </div>
          <div class="step-info">
            <p>{{ 'landing.steps.step1.a' | translate }}</p>
            <p>{{ 'landing.steps.step1.b' | translate }}</p>
          </div>
        </div>
        <div class="step step02">
          <div class="step-number">2</div>
          <div class="step-title">
            <span>{{ 'landing.steps.step2.title' | translate }}</span>
          </div>
          <div class="step-info">
            <span>{{ 'landing.steps.step2.info' | translate }}</span>
          </div>
        </div>
        <div class="step step03">
          <div class="step-number">3</div>
          <div class="step-title">
            <span>{{ 'landing.steps.step3.title' | translate }}</span>
          </div>
          <div class="step-info">
            <span>{{ 'landing.steps.step3.info' | translate }}</span>
          </div>
        </div>
        <div class="step step04">
          <div class="step-number">4</div>
          <div class="step-title">
            <span>{{ 'landing.steps.step4.title' | translate }}</span>
          </div>
          <div class="step-info">
            <span>{{ 'landing.steps.step4.info' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="bottom">
        <button class="warn transparent" mat-flat-button (click)="onClick()">
          <span>{{ 'landing.button' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
